import {ready} from '~/core/indexConf'

ready('dataTable', '.dataTable', el => {
    const table = document.querySelector(".dataTable");
    const rows = [...table.querySelectorAll(".dataTable tr")];
    const headers = [...table.querySelectorAll(".dataTable th")];
    const cells = [...table.querySelectorAll(".dataTable td")];
    cells.forEach(cell => cell.setAttribute("data-position", cell.cellIndex + 1));
    headers.forEach((header) => {
        header.setAttribute("data-position", header.cellIndex + 1)
        let headerText = header.innerHTML
        let headerPosition = header.dataset.position;
        let matches = table.querySelectorAll(`.dataTable td[data-position='${headerPosition}']`)
        matches.forEach((match) => {
        let cellTitle = document.createElement('div')
        cellTitle.innerHTML= headerText
        cellTitle.classList.add('dataTable-cellTitle')
            match.insertBefore(cellTitle, match.firstChild)
        });
    });
})